var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShare = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 15V3M8 7l4-4 4 4M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"
})));
SvgShare.viewBox = '0 0 24 24';
const ForwardRef = /*#__PURE__*/forwardRef(SvgShare);
export default ForwardRef;